/* src/app/dashboard/ui/components/toolbar/toolbar.component.scss */
a {
  cursor: pointer;
}
.header {
  position: fixed;
  width: 100%;
  height: 72px;
  z-index: 1200;
  background: #363954;
  color: #fff;
  font-size: 14px;
}
.flex {
  display: flex;
  position: relative;
  height: 100%;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  white-space: nowrap;
  padding: 0 30px;
  max-width: 1400px;
}
.left {
  height: 100%;
}
.home-link-wrapper {
  display: inline-block;
  vertical-align: top;
  margin-top: 18px;
  margin-right: 20px;
}
.home-link-wrapper .home-link {
  color: #ffffff;
}
.map-title {
  display: inline-block;
  vertical-align: top;
}
.map-title p {
  margin-top: 16px;
  margin-bottom: 0px;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.5;
  color: #fff;
}
.map-title a {
  display: block;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.map-title a:hover {
  text-decoration: underline;
  text-decoration: underline 1px solid;
  text-underline-offset: 2px;
}
.caption {
  display: inline-block;
  font-weight: 700;
  white-space: pre-wrap;
}
.right {
  display: flex;
  align-items: center;
  border-right: 1px solid #141522;
}
.right > .user {
  padding-right: 20px;
}
.logo {
  padding: 0 20px;
  height: 25px;
  width: auto;
}
.user {
  border-right: 1px solid #141522;
}
.user .icon {
  position: relative;
  z-index: 1100;
  display: block;
  height: 42px;
  width: 42px;
  border-radius: 50%;
  cursor: pointer;
  background-color: transparent;
  object-fit: cover;
}
.user-nav-overlay {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
}
.user-nav {
  position: absolute;
  top: 65px;
  right: -94px;
  z-index: 1300;
  padding: 28px 35px;
  width: 268px;
  border-radius: 8px;
  background-color: #fff;
  color: #333;
  box-shadow: 0 0 6px 2px #a8a7be;
}
.user-nav::after {
  content: "";
  position: absolute;
  top: -39px;
  right: 118px;
  margin-left: -17px;
  border: 16px solid transparent;
  border-bottom: 24px solid #fff;
}
.user-nav a {
  display: inline-block;
  width: 100%;
  color: #333;
}
.user-nav a:hover {
  text-decoration: underline;
}
.user > .mobile {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1300;
  padding: 20px 10vw;
  width: 100%;
  min-height: 100vh;
  background-color: #373a52;
  color: #ccc;
  border: none;
  border-radius: 0;
}
.user > .mobile .user-info {
  margin-bottom: 20px;
}
.user > .mobile li a {
  width: 100%;
  color: #fff;
}
.user > .mobile > a {
  padding: 8px 0;
}
.user > .mobile::before,
.user > .mobile::after {
  border: none;
}
.user > .mobile .close {
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 8px;
  width: 30px;
  height: 30px;
}
.user > .mobile .menu {
  margin-top: 40px;
}
.user > .mobile .menu li {
  border-bottom: none;
}
.user > .mobile .menu a {
  position: relative;
  display: inline-block;
  margin-top: 5px;
  padding-bottom: 5px;
  width: 100%;
  border-bottom: 1px solid #ccc;
}
.user > .mobile .menu a::after {
  position: absolute;
  right: 0;
  top: 3px;
  content: "\f054";
  font-family: "Font Awesome 5 Free";
  font-weight: 700;
  color: #ccc;
}
.user > .mobile .menu li:nth-of-type(n+5) a {
  color: #ccc;
  border-bottom-color: #999;
}
.user > .mobile .menu li:nth-of-type(n+5) a::after {
  color: #999;
}
.user > .mobile .menu li:nth-of-type(n+7) a {
  color: #999;
  border-bottom: none;
}
.user > .mobile .logout {
  background-color: #cbcad1;
  color: #000;
}
.user-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 0;
  padding-bottom: 8px;
  border-radius: 12px 12px 0 0;
  text-align: center;
}
.user-info + a {
  padding: 8px 4px;
  display: block;
  text-align: center;
  color: #000;
  background-color: #d6d4f1;
}
.user-info > .icon {
  cursor: initial;
}
.user-detail {
  margin: 8px 0 0 0;
  white-space: normal;
  word-break: break-all;
}
.user-name {
  font-weight: 500;
}
.user-email {
  font-weight: 700;
}
.logout {
  display: block;
  margin: 40px auto 0px;
  padding: 9px;
  text-align: center;
  font-weight: 500;
  background-color: #e5e7f5;
}
.menu {
  list-style: none;
  margin-top: 8px;
  margin-bottom: 0;
  padding: 0;
  font-weight: 500;
}
.menu li {
  padding: 0 4px 4px;
  border-bottom: 1px solid #e5e7f3;
}
.menu li:nth-of-type(n+2) {
  margin-top: 8px;
}
.menu li:nth-of-type(1),
.menu li:nth-of-type(2) {
  margin-top: 50px;
}
.menu li:last-of-type {
  padding-bottom: 0;
}
a {
  text-decoration: none;
}
.to-top {
  position: fixed;
  bottom: 40px;
  z-index: 1200;
  width: 50px;
  height: auto;
  transition: 0.25s;
  transition-timing-function: ease-out;
  transition-duration: 0;
}
.to-top-visible {
  opacity: 1;
  visibility: visible;
}
.to-top-hidden {
  opacity: 0;
  visibility: hidden;
}
@media screen and (max-width: 1024px) {
  .mobile .flex {
    padding: 0 8px;
  }
  .mobile .caption {
    font-size: 18px;
  }
  .right,
  .user {
    border-right: none;
  }
  .right > .user {
    padding-right: 0;
  }
  .user > .icon {
    margin-right: 0;
  }
  .user-nav {
    right: 20px;
  }
  .user-nav::before {
    right: 8px;
  }
  .user-nav::after {
    right: 6px;
  }
  .to-top {
    bottom: 100px;
    right: 20px;
  }
}
.login-form {
  padding-right: 20px;
  border-right: 1px solid #141522;
}
.login-form > input {
  width: 8rem;
}
.login-form > p {
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
}
.not-login a {
  color: #fff;
  text-decoration: none;
}
/*# sourceMappingURL=toolbar.component-UWZA4D3S.css.map */
